export default "__VITE_ASSET__CrHQOWJw__"